<template>
  <div class="ntf-root" :data-sidebar="darkMode ? 'dark' : 'light'">
    <div class="ntf-topbar">
      <div class="container d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <button class="ntf-back" @click="goBack"><i class="mdi mdi-arrow-left"></i></button>
          <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:30px;" /></a>
          <span style="color:var(--fm-h,#F5F0E8);font-weight:700;font-size:18px;">Notifications</span>
          <span v-if="unread > 0" class="ntf-topbar-badge">{{ unread }}</span>
        </div>
        <div class="d-flex gap-2">
          <a href="javascript:void(0)" @click="$router.push('/messages')" class="btn btn-sm btn-outline-secondary"><i class="mdi mdi-message-text me-1"></i>Messages</a>
          <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="btn btn-sm btn-outline-warning">Dashboard</a>
        </div>
      </div>
    </div>
    <div class="container ntf-container">
      <div class="ntf-tabs mb-3">
        <button v-for="tab in tabs" :key="tab.value" :class="{ active: activeTab === tab.value }" @click="activeTab = tab.value">{{ tab.label }}</button>
        <button v-if="unread > 0" class="ms-auto ntf-mark-all" @click="markAllRead">Mark all read</button>
      </div>

      <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

      <div v-else-if="filtered.length === 0" class="text-center py-5">
        <i class="mdi mdi-bell-outline" style="font-size:56px;color:var(--fm-s,#2A2520);"></i>
        <p class="mt-3" style="color:var(--fm-s,#6B6356);">No notifications</p>
      </div>

      <div v-else>
        <template v-for="sec in sections" :key="sec.label">
          <div class="ntf-group">{{ sec.label }}</div>
          <div v-for="n in sec.items" :key="n.id" class="ntf-card" :class="{ unread: Number(n.is_read)===0 }" @click="handleClick(n)">
            <div class="ntf-icon-wrap" :class="iconClass(n.category)">
              <i class="mdi" :class="iconFor(n.category)"></i>
            </div>
            <div class="flex-fill" style="min-width:0;">
              <div class="ntf-title">{{ n.title }}</div>
              <div class="ntf-body">{{ displayBody(n) }}</div>
              <div class="ntf-time">{{ timeAgo(n.created_at) }}</div>
            </div>
            <div v-if="Number(n.is_read)===0" class="ntf-dot"></div>
          </div>
        </template>

        <button v-if="hasMore" class="btn btn-outline-secondary btn-sm w-100 mt-3" @click="loadMore" :disabled="loadingMore">
          <span v-if="loadingMore"><span class="spinner-border spinner-border-sm me-1"></span></span>
          Load More
        </button>
      </div>
    </div>
  </div>
</template>

<style>
:root{
  --fm-h:#F5F0E8;
  --fm-s:#6B6356;
  --fm-m:#A09888;
  --fm-bg1:#141414;
  --fm-bg2:#0F0F0F;
  --fm-bg3:#1E1E1E;
  --fm-br:#1E1E1E;
  --fm-page:#0A0A0A;
}
html[data-theme="light"]{
  --fm-h:#1A1A1A;
  --fm-s:#777;
  --fm-m:#555;
  --fm-bg1:#FFFFFF;
  --fm-bg2:#F0EBE4;
  --fm-bg3:#E9E4DC;
  --fm-br:#E2DCD3;
  --fm-page:#EBE7E1;
}
html[data-theme="light"] body,
html[data-theme="light"] #layout-wrapper,
html[data-theme="light"] .ntf-root,
html[data-theme="light"] .ntf-container{
  background:var(--fm-page)!important;
  color:var(--fm-h)!important;
}
html[data-theme="dark"] body,
html[data-theme="dark"] #layout-wrapper,
html[data-theme="dark"] .ntf-root,
html[data-theme="dark"] .ntf-container{
  background:var(--fm-page)!important;
  color:var(--fm-h)!important;
}
html[data-theme="light"] .ntf-topbar{
  background:#FFFFFF!important;
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="dark"] .ntf-topbar{
  background:var(--fm-bg1,#141414)!important;
}
html[data-theme="light"] .ntf-card{
  background:#FFFFFF!important;
  border-color:#E8E2DA!important;
}
html[data-theme="light"] .ntf-card.unread{
  background:#FFF8F0!important;
  border-color:#E8E2DA!important;
}
html[data-theme="light"] .ntf-title{
  color:#1A1A1A!important;
}
html[data-theme="light"] .ntf-body,
html[data-theme="light"] .ntf-time,
html[data-theme="light"] .ntf-tabs button{
  color:#555!important;
}
html[data-theme="light"] .ntf-tabs button{
  background:#FFFFFF!important;
  border-color:#E8E2DA!important;
}
html[data-theme="light"] .ntf-tabs button.active{
  background:rgba(191,161,100,0.15)!important;
  border-color:#BFA164!important;
  color:#BFA164!important;
}
</style>

<style scoped>
.ntf-root{background:var(--fm-page,#0A0A0A)!important;min-height:100vh;color:var(--fm-h,#F5F0E8)}
.ntf-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.ntf-topbar-badge{background:#FF6B6B;color:#fff;font-size:11px;font-weight:700;padding:1px 7px;border-radius:10px}
.ntf-back{width:36px;height:36px;border-radius:50%;border:none;background:var(--fm-bg2,#0F0F0F);color:var(--fm-h,#F5F0E8);font-size:19px}
.ntf-group{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:15px;margin:14px 2px 8px}
.ntf-card.unread{border-left:3px solid #BFA164}
.ntf-container{padding-top:80px;padding-bottom:60px;max-width:700px}
.ntf-tabs{display:flex;gap:6px;overflow-x:auto;scrollbar-width:none;align-items:center}
.ntf-tabs::-webkit-scrollbar{display:none}
.ntf-tabs button{white-space:nowrap;padding:6px 14px;border-radius:16px;border:1px solid var(--fm-br,#2A2520);background:var(--fm-bg1,#141414);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .2s}
.ntf-tabs button.active{background:rgba(191,161,100,0.15);border-color:#BFA164;color:#BFA164}
.ntf-mark-all{border:none!important;background:none!important;color:#50C878!important;font-size:12px!important;padding:6px 0!important}
.ntf-card{display:flex;align-items:flex-start;gap:12px;padding:16px;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;margin-bottom:8px;cursor:pointer;transition:all .2s}
.ntf-card:hover{border-color:#2A2520;transform:translateX(2px)}
.ntf-card.unread{background:#1A1708;border-color:#2A2520}
.ntf-icon-wrap{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0}
.ntf-icon-wrap.order{background:rgba(191,161,100,0.1);color:#BFA164}
.ntf-icon-wrap.payment{background:rgba(80,200,120,0.1);color:#50C878}
.ntf-icon-wrap.offer{background:rgba(80,165,241,0.1);color:#50a5f1}
.ntf-icon-wrap.message{background:rgba(155,89,182,0.1);color:#9b59b6}
.ntf-icon-wrap.system{background:rgba(255,171,0,0.1);color:#FFAB00}
.ntf-icon-wrap.dispute{background:rgba(255,107,107,0.1);color:#FF6B6B}
.ntf-icon-wrap.default{background:rgba(160,152,136,0.1);color:var(--fm-m,#A09888)}
.ntf-title{font-size:13px;font-weight:600;color:var(--fm-h,#F5F0E8);margin-bottom:2px}
.ntf-body{font-size:12px;color:var(--fm-s,#6B6356);overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
.ntf-time{font-size:10px;color:#4A4540;margin-top:4px}
.ntf-dot{width:8px;height:8px;border-radius:50%;background:#BFA164;flex-shrink:0;margin-top:6px}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .ntf-container { padding-left: 12px !important; padding-right: 12px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)); }
  .ntf-card { padding: 12px; border-radius: 10px; }
  .ntf-icon-wrap { width: 36px; height: 36px; font-size: 18px; }
  .ntf-title { font-size: 13px; }
  .ntf-body { font-size: 12px; }
}
</style>

<script>
/* eslint-disable */
import { execute, flocker } from "@/api";

function applyNotificationsTheme(vm) {
  const t = document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || (vm && vm.darkMode ? 'dark' : 'light');
  const isDark = t !== 'light';
  if (vm) vm.darkMode = isDark;
  window.__flockrSetTheme(isDark ? 'dark' : 'light');

  if (document.body) {
    document.body.setAttribute('data-sidebar', isDark ? 'dark' : 'light');
    document.body.style.background = isDark ? '#0A0A0A' : '#EBE7E1';
    document.body.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }

  const wrapper = document.getElementById('layout-wrapper');
  if (wrapper) {
    wrapper.style.background = isDark ? '#0A0A0A' : '#EBE7E1';
    wrapper.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }
}

export default {
  name: "NotificationsPage",
  data() {
    return {
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
      themeObserver: null,
      loading: true, notifications: [], unread: 0, activeTab: 'all',
      page: 1, hasMore: true, loadingMore: false,
      tabs: [
        { label: 'All', value: 'all' },{ label: 'Orders', value: 'order' },
        { label: 'Payments', value: 'payment' },{ label: 'Offers', value: 'offer' },
        { label: 'Messages', value: 'message' },{ label: 'System', value: 'system' }
      ]
    };
  },
  computed: {
    filtered() {
      if (this.activeTab === 'all') return this.notifications;
      var t = this.activeTab;
      return this.notifications.filter(function(n) { return n.category === t; });
    },
    sections() {
      var list = this.filtered;
      var unread = list.filter(function(n){ return Number(n.is_read) === 0; });
      var read = list.filter(function(n){ return Number(n.is_read) !== 0; });
      var s = [];
      if (unread.length) s.push({ label: 'New', items: unread });
      if (read.length) s.push({ label: 'Earlier', items: read });
      return s;
    }
  },
  mounted() {
    applyNotificationsTheme(this);
    this.themeObserver = new MutationObserver(() => applyNotificationsTheme(this));
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });
    this.load();
  },
  beforeUnmount() {
    if (this.themeObserver) this.themeObserver.disconnect();
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push('/dashboard');
    },
    displayBody(n) {
      var body = n.body || n.message || '';
      if (typeof body === 'string' && body.trim().charAt(0) === '{') {
        try {
          var parsed = JSON.parse(body);
          if (parsed._type === 'listing_card') return 'Shared a listing';
          if (parsed._type === 'offer_card') return 'Shared an offer';
          if (parsed._type === 'order_card') return 'Shared an order';
          if (parsed._type === 'image') return 'Sent a photo';
          if (parsed._type) return 'Sent a ' + parsed._type.replace(/_/g, ' ');
          return 'Sent an attachment';
        } catch (e) {
          if (body.indexOf('"listing_card"') !== -1) return 'Shared a listing';
          if (body.indexOf('"offer_card"') !== -1) return 'Shared an offer';
          if (body.indexOf('"order_card"') !== -1) return 'Shared an order';
          if (body.indexOf('"image"') !== -1) return 'Sent a photo';
          return 'Sent an attachment';
        }
      }
      return body;
    },
    iconFor(cat) {
      var m = { order: 'mdi-receipt', payment: 'mdi-cash', offer: 'mdi-tag-heart', message: 'mdi-message-text', system: 'mdi-cog', dispute: 'mdi-gavel' };
      return m[cat] || 'mdi-bell';
    },
    iconClass(cat) { return ['order','payment','offer','message','system','dispute'].indexOf(cat) >= 0 ? cat : 'default'; },
    timeAgo(d) {
      if (!d) return '';
      var s = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
      if (s < 60) return 'just now';
      if (s < 3600) return Math.floor(s / 60) + 'm ago';
      if (s < 86400) return Math.floor(s / 3600) + 'h ago';
      if (s < 604800) return Math.floor(s / 86400) + 'd ago';
      return new Date(d).toLocaleDateString('en-KE', { day: 'numeric', month: 'short' });
    },
    async load() {
      this.loading = true;
      var userId = sessionStorage.getItem('userId');
      if (!userId) { this.$router.push('/login'); return; }
      try {
        var f = new FormData();
        f.append('function', 'getNotifications');
        f.append('userId', userId);
        f.append('page', this.page);
        f.append('limit', 20);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.notifications = r.data.data.notifications || [];
          this.unread = r.data.data.unread || 0;
          this.hasMore = this.notifications.length >= 20;
          // Opening the page clears the unread badge (server + bell) but keeps
          // items highlighted as "New" for this session.
          if (this.unread > 0) this._clearBadge();
        }
      } catch (e) { console.error(e); }
      this.loading = false;
    },
    async _clearBadge() {
      var userId = sessionStorage.getItem('userId');
      if (!userId) return;
      this.unread = 0;
      window.dispatchEvent(new CustomEvent('flockr-notifications-changed'));
      try {
        var f = new FormData();
        f.append('function', 'markNotificationRead');
        f.append('userId', userId);
        f.append('markAll', '1');
        await execute(f, flocker);
      } catch (e) {}
    },
    async loadMore() {
      this.loadingMore = true;
      this.page++;
      var userId = sessionStorage.getItem('userId');
      try {
        var f = new FormData();
        f.append('function', 'getNotifications');
        f.append('userId', userId);
        f.append('page', this.page);
        f.append('limit', 20);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          var more = r.data.data.notifications || [];
          this.notifications = this.notifications.concat(more);
          this.hasMore = more.length >= 20;
        }
      } catch (e) { console.error(e); }
      this.loadingMore = false;
    },
    async handleClick(n) {
      if (!n.is_read) {
        var userId = sessionStorage.getItem('userId');
        try {
          var f = new FormData();
          f.append('function', 'markNotificationRead');
          f.append('notificationId', n.id);
          f.append('userId', userId);
          await execute(f, flocker);
          n.is_read = 1;
          this.unread = Math.max(0, this.unread - 1);
          window.dispatchEvent(new CustomEvent('flockr-notifications-changed'));
        } catch (e) {}
      }
      // Tag the destination so the next page knows to show "Back to notifications"
      try { sessionStorage.setItem('flockr_nav_from', 'notifications'); } catch(e){}
      if (n.action_url) this.$router.push(n.action_url);
      else if (n.category === 'order' && n.reference_id) this.$router.push('/orders/' + n.reference_id);
      else if (n.category === 'message' && n.reference_id) this.$router.push('/messages/' + n.reference_id);
      else if (n.category === 'message') this.$router.push('/messages');
      else if (n.category === 'offer' && n.reference_id) this.$router.push('/marketplace/listing/' + n.reference_id);
      else if (n.category === 'offer') this.$router.push('/marketplace/offers');
    },
    async markAllRead() {
      var userId = sessionStorage.getItem('userId');
      try {
        var f = new FormData();
        f.append('function', 'markNotificationRead');
        f.append('userId', userId);
        f.append('markAll', '1');
        await execute(f, flocker);
        this.notifications.forEach(function(n) { n.is_read = 1; });
        this.unread = 0;
        window.dispatchEvent(new CustomEvent('flockr-notifications-changed'));
      } catch (e) { console.error(e); }
    }
  }
};
</script>